export const SETTINGS_SECTION_IDS = [
  "general",
  "profile",
  "trading",
  "access",
  "security",
] as const;

export type SettingsSectionId = (typeof SETTINGS_SECTION_IDS)[number];

/**
 * Where Settings opens when no section is requested: the first section in the
 * registry, so reordering the rail moves the landing section with it.
 */
export const DEFAULT_SETTINGS_SECTION_ID: SettingsSectionId =
  SETTINGS_SECTION_IDS[0];

export interface AppSettingsSearch {
  settings?: SettingsSectionId;
}

export interface SettingsSectionDefinition {
  id: SettingsSectionId;
}

export const SETTINGS_SECTION_REGISTRY: readonly SettingsSectionDefinition[] = [
  {
    id: "general",
  },
  {
    id: "profile",
  },
  {
    id: "trading",
  },
  {
    id: "access",
  },
  {
    id: "security",
  },
] as const;

export function isSettingsSectionId(
  value: unknown,
): value is SettingsSectionId {
  return SETTINGS_SECTION_IDS.includes(value as SettingsSectionId);
}

export function normalizeSettingsSectionId(
  value: unknown,
): SettingsSectionId | undefined {
  return isSettingsSectionId(value) ? value : undefined;
}

export function normalizeAppSettingsSearch(
  raw: Record<string, unknown>,
): AppSettingsSearch {
  const settings = normalizeSettingsSectionId(raw.settings);
  return settings ? { settings } : {};
}

export function applySettingsSectionToSearch(
  search: Record<string, unknown>,
  section: SettingsSectionId,
): Record<string, unknown> {
  return {
    ...search,
    settings: section,
  };
}

export function removeSettingsSectionFromSearch(
  search: Record<string, unknown>,
): Record<string, unknown> {
  const nextSearch = {
    ...search,
  };

  delete nextSearch.settings;
  return nextSearch;
}
